import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
  init() {
    const elements = document.querySelectorAll("[data-scrollto]");
    elements.forEach((element) => {
      const targetSelector = element.getAttribute("data-scrollto");
      const targetElement = document.querySelector(targetSelector);

      if (targetElement) {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          const targetY =
            targetElement.getBoundingClientRect().top + window.pageYOffset - 80;
          gsap.to(window, {
            scrollTo: { y: targetY, autoKill: false },
            duration: 0.5,
            ease: "power2.out",
          });
        });
      }
    });

    const top = document.querySelector(".top");
    if (top) {
      window.addEventListener("scroll", () => {
        const scrollPosition = window.scrollY;
        const viewportHeight = window.innerHeight;

        if (scrollPosition > viewportHeight) {
          gsap.to(top, {
            opacity: 1,
            pointerEvents: "auto",
            duration: 0.3,
            ease: "power2.out",
          });
        } else {
          gsap.to(top, {
            opacity: 0,
            pointerEvents: "none",
            duration: 0.3,
            ease: "power2.out",
          });
        }
      });
    }
  },
};
